import React, { useEffect, useState } from "react";
import { Button, Checkbox, Radio, Loader, Progress, Icon, Header, Segment } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./index.scss";

import VitalityGauge from "./VitalityGauge";

import { setUser } from "../../../redux/auth/actions";

import api from "../../../services/api";
import { LowFatigability, MediumFatigability, HighFatigability } from "../../../data/fatigability";
import { InsertExcercises, DeleteExistingExcercises, InsertPauses, DeleteExistingPauses, InsertNewFatigability } from "../Services";

const Onboarding = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({
    gender: "",
    age: "",
    needs: [],
    screenTime: "",
    currentPractices: [],
    visualIssues: [],
    postureIssues: [],
  });

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.Auth);

  useEffect(() => {
    setAnswers({
      gender: user.gender,
      age: user.age,
      needs: user.needs || [],
      screenTime: user.screenTime,
      currentPractices: user.currentPractices || [],
      visualIssues: user.visualIssues || [],
      postureIssues: user.postureIssues || [],
    });
  }, [user]);

  const nextStep = async () => {
    await saveAnswers();
    setCurrentStep(currentStep + 1);
  };

  const saveAnswers = async () => {
    try {
      if (currentStep === slides.length - 2) answers.onboarding = true;
      const { data } = await api.put(`/api/users/${user.id}`, answers);
      dispatch(setUser(data));
    } catch (error) {
      console.error(error);
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const slides = [];
  slides.push(<Welcome />);
  slides.push(<Gender answers={answers} setAnswers={setAnswers} />);
  slides.push(<AgeRange answers={answers} setAnswers={setAnswers} />);
  slides.push(<Needs answers={answers} setAnswers={setAnswers} />);
  slides.push(<Transition />);
  slides.push(<ScreenTime answers={answers} setAnswers={setAnswers} />);
  slides.push(<CurrentPractices answers={answers} setAnswers={setAnswers} />);
  slides.push(<VisualIssues answers={answers} setAnswers={setAnswers} />);
  slides.push(<PostureIssues answers={answers} setAnswers={setAnswers} />);
  slides.push(<ThankYou />);
  slides.push(<RiskIndex answers={answers} setAnswers={setAnswers} />);
  slides.push(<Program />);

  return (
    <div
      className="onboarding-container"
      style={{ width: "100%", maxWidth: "900px", margin: "0 auto", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", padding: "10px" }}
    >
      <Progress value={currentStep + 1} total={slides.length} progress="ratio" success={currentStep === slides.length - 1} color="green" style={{ width: "100%" }} />

      <div style={{ width: "100%", flex: 2 }}>{slides[currentStep]}</div>

      <div style={{ display: "flex", justifyContent: "space-between", margin: "auto auto", width: "100%" }}>
        {currentStep > 0 && (
          <Button onClick={prevStep}>
            <Icon name="arrow left" /> Précédent
          </Button>
        )}
        {currentStep < slides.length - 1 && (
          <Button primary onClick={nextStep} disabled={currentStep === 3 && (answers.needs?.length === 0 || answers.needs?.length > 3)} style={{ marginLeft: "auto" }}>
            Suivant <Icon name="arrow right" />
          </Button>
        )}
      </div>
    </div>
  );
};

const Welcome = () => {
  return (
    <div key="welcome">
      <Header as="h2" textAlign="center">
        🎉 Bienvenue chez VIZYGOOD – Mission : Sauver vos yeux et votre dos ! 🎉
      </Header>
      <Segment padded>
        <p>Avant de démarrer, faisons un peu plus connaissance... avec le sourire et sans stress.</p>
        <p>C'est juste pour mieux vous aider ! 😄</p>
      </Segment>
    </div>
  );
};

const Gender = ({ answers, setAnswers }) => {
  return (
    <div key="gender">
      <Header as="h2" textAlign="center">
        🕵️‍♂️ Vous êtes…
      </Header>
      <Segment padded>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Radio label="Un Homme" name="gender" value="male" checked={answers.gender === "male"} onChange={() => setAnswers({ ...answers, gender: "male" })} />
          <Radio label="Une Femme" name="gender" value="female" checked={answers.gender === "female"} onChange={() => setAnswers({ ...answers, gender: "female" })} />
          <Radio
            label="Un expert de la discrétion (Je ne souhaite pas répondre)"
            name="gender"
            value="undisclosed"
            checked={answers.gender === "undisclosed"}
            onChange={() => setAnswers({ ...answers, gender: "undisclosed" })}
          />
        </div>
      </Segment>
    </div>
  );
};

const AgeRange = ({ answers, setAnswers }) => {
  return (
    <div key="age">
      <Header as="h2" textAlign="center">
        📅 Votre tranche d'âge :
      </Header>
      <Segment padded>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Radio
            label="18-30 ans (un(e) jeune explorateur/trice)"
            name="age"
            value="18-30"
            checked={answers.age === "18-30"}
            onChange={() => setAnswers({ ...answers, age: "18-30" })}
          />
          <Radio
            label="31-45 ans (un(e) aventurier/ière confirmé(e))"
            name="age"
            value="31-45"
            checked={answers.age === "31-45"}
            onChange={() => setAnswers({ ...answers, age: "31-45" })}
          />
          <Radio label="46-65 ans (un sage expérimenté)" name="age" value="46-65" checked={answers.age === "46-65"} onChange={() => setAnswers({ ...answers, age: "46-65" })} />
          <Radio label="66 ans et plus (une légende vivante)" name="age" value="66+" checked={answers.age === "66+"} onChange={() => setAnswers({ ...answers, age: "66+" })} />
        </div>
      </Segment>
    </div>
  );
};

const Needs = ({ answers, setAnswers }) => {
  const handleMultipleChoice = (field, value) => {
    if (answers[field].includes(value)) {
      setAnswers({ ...answers, [field]: answers[field].filter((item) => item !== value) });
    } else {
      if (answers[field].length >= 3) {
        return;
      }
      setAnswers({ ...answers, [field]: [...answers[field], value] });
    }
  };
  return (
    <div key="needs">
      <Header as="h2" textAlign="center">
        👀 Quels sont vos besoins face aux écrans ?
      </Header>
      <Segment padded>
        <p>(Choisissez 3 options maximum, on ne peut pas tout régler d'un coup 😜)</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Checkbox label="Avoir des yeux toniques et pleins de vie" checked={answers.needs?.includes("tonic-eyes")} onChange={() => handleMultipleChoice("needs", "tonic-eyes")} />
          <Checkbox
            label="Avoir une posture équilibrée comme un funambule"
            checked={answers.needs?.includes("balanced-posture")}
            onChange={() => handleMultipleChoice("needs", "balanced-posture")}
          />
          <Checkbox label="Acquérir des habitudes saines" checked={answers.needs?.includes("healthy-habits")} onChange={() => handleMultipleChoice("needs", "healthy-habits")} />
          <Checkbox
            label="Être moins fatigué(e) en fin de journée"
            checked={answers.needs?.includes("less-fatigue")}
            onChange={() => handleMultipleChoice("needs", "less-fatigue")}
          />
          <Checkbox label="M'entretenir tout simplement" checked={answers.needs?.includes("maintenance")} onChange={() => handleMultipleChoice("needs", "maintenance")} />
        </div>
        {answers.needs?.length > 3 && <p style={{ color: "red", marginTop: "10px" }}>Vous avez sélectionné plus de 3 options. Veuillez en désélectionner.</p>}
      </Segment>
    </div>
  );
};

const Transition = () => {
  return (
    <div key="transition">
      <Header as="h2" textAlign="center">
        Top ! Nous vous suivons !
      </Header>
      <Segment padded>
        <p>➡️ Nous allons vous concocter un programme sur-mesure.</p>
        <p>Mais avant, pouvez-vous nous en dire plus sur vous ?</p>
      </Segment>
    </div>
  );
};

const ScreenTime = ({ answers, setAnswers }) => {
  return (
    <div key="screenTime">
      <Header as="h2" textAlign="center">
        📱 Combien de temps passez-vous chaque jour sur les écrans ?
      </Header>
      <Segment padded>
        <p>(Tout écran confondu : boulot, maison, TV, téléphone… oui, oui, tout compte ! 😆)</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Radio
            label="Moins de 4h (Bravo, vous avez une vie sociale ! 🎉)"
            name="screenTime"
            value="<4"
            checked={answers.screenTime === "<4"}
            onChange={() => setAnswers({ ...answers, screenTime: "<4" })}
          />
          <Radio
            label="4 à 7h (Une utilisation raisonnable, on vous félicite 👌)"
            name="screenTime"
            value="4-7"
            checked={answers.screenTime === "4-7"}
            onChange={() => setAnswers({ ...answers, screenTime: "4-7" })}
          />
          <Radio
            label="7 à 10h (Vous et votre écran, une grande histoire d'amour 📲)"
            name="screenTime"
            value="7-10"
            checked={answers.screenTime === "7-10"}
            onChange={() => setAnswers({ ...answers, screenTime: "7-10" })}
          />
          <Radio
            label="Plus de 10h (Vous êtes officiellement un(e) cyborg 💾)"
            name="screenTime"
            value="10+"
            checked={answers.screenTime === "10+"}
            onChange={() => setAnswers({ ...answers, screenTime: "10+" })}
          />
        </div>
      </Segment>
    </div>
  );
};

const CurrentPractices = ({ answers, setAnswers }) => {
  const handleMultipleChoice = (value) => {
    let updatedPractices;
    if (value === "nothing") {
      updatedPractices = ["nothing"];
    } else if (answers.currentPractices?.includes("nothing")) {
      updatedPractices = [value];
    } else if (answers.currentPractices?.includes(value)) {
      updatedPractices = answers.currentPractices.filter((item) => item !== value);
    } else {
      updatedPractices = [...(answers.currentPractices || []), value];
    }
    setAnswers({ ...answers, currentPractices: updatedPractices });
  };
  return (
    <div key="practices">
      <Header as="h2" textAlign="center">
        💪 Faites-vous déjà quelque chose pour vos yeux et votre posture ?
      </Header>
      <Segment padded>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Checkbox
            label="Des pauses régulières (Bravo, vous savez vous détendre)"
            checked={answers.currentPractices?.includes("breaks")}
            onChange={() => handleMultipleChoice("breaks")}
          />
          <Checkbox
            label="Des exercices visuels (Vos yeux sont en pleine forme)"
            checked={answers.currentPractices?.includes("visual-exercises")}
            onChange={() => handleMultipleChoice("visual-exercises")}
          />
          <Checkbox
            label="Des étirements du dos (Vous êtes souple comme un roseau)"
            checked={answers.currentPractices?.includes("stretching")}
            onChange={() => handleMultipleChoice("stretching")}
          />
          <Checkbox
            label="Je ne fais rien de tout ça… mais j'y pense (Pas de panique, on est là pour ça !)"
            checked={answers.currentPractices?.includes("nothing")}
            onChange={() => handleMultipleChoice("nothing")}
          />
        </div>
      </Segment>
    </div>
  );
};

const VisualIssues = ({ answers, setAnswers }) => {
  const handleMultipleChoice = (value) => {
    let updatedIssues;
    if (value === "none") {
      updatedIssues = ["none"];
    } else if (answers.visualIssues?.includes("none")) {
      updatedIssues = [value];
    } else if (answers.visualIssues?.includes(value)) {
      updatedIssues = answers.visualIssues.filter((item) => item !== value);
    } else {
      updatedIssues = [...(answers.visualIssues || []), value];
    }
    setAnswers({ ...answers, visualIssues: updatedIssues });
  };

  return (
    <div key="visualIssues">
      <Header as="h2" textAlign="center">
        😵 Avez-vous des troubles visuels ?
      </Header>
      <Segment padded>
        <p>(Cochez ce qui vous concerne)</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Checkbox
            label="Fatigue visuelle (La team des yeux explosés 😵)"
            checked={answers.visualIssues?.includes("VisualFatigue")} // VisualFatigue
            onChange={() => handleMultipleChoice("VisualFatigue")}
          />
          <Checkbox
            label="Larmoiements (On dira que c'est l'émotion 😢)"
            checked={answers.visualIssues?.includes("Larmoiements")} // Larmoiements
            onChange={() => handleMultipleChoice("Larmoiements")}
          />
          <Checkbox
            label="Yeux secs (Sensation désert du Sahara 🌵)"
            checked={answers.visualIssues?.includes("Sechese")} // Sechese
            onChange={() => handleMultipleChoice("Sechese")}
          />
          <Checkbox
            label="Picotements (Comme si un mini-sable mouvant était tombé dans vos yeux)"
            checked={answers.visualIssues?.includes("Picotements")} // Picotements
            onChange={() => handleMultipleChoice("Picotements")}
          />
          <Checkbox
            label="Vision floue (Ou alors il faut juste nettoyer l'écran ? 🤔)"
            checked={answers.visualIssues?.includes("VisionFloue")} // VisionFloue
            onChange={() => handleMultipleChoice("VisionFloue")}
          />
          <Checkbox
            label="Maux de tête et/ou migraines (Aïe, ça cogne 😣)"
            checked={answers.visualIssues?.includes("Migraines")} // Migraines
            onChange={() => handleMultipleChoice("Migraines")}
          />
          <Checkbox
            label="Vision double (Si vous voyez ce questionnaire en double, c'est peut-être un signe 😅)"
            checked={answers.visualIssues?.includes("VisionDouble")} // VisionDouble
            onChange={() => handleMultipleChoice("VisionDouble")}
          />
          <Checkbox
            label="Troubles de la concentration (Attendez, de quoi on parlait déjà ? 🤯)"
            checked={answers.visualIssues?.includes("Concentration")} // Concentration
            onChange={() => handleMultipleChoice("Concentration")}
          />
          <Checkbox
            label="Aucune gêne visuelle (Vous avez des yeux en béton armé, bravo ! 👏)"
            checked={answers.visualIssues?.includes("none")} // Aucune gêne visuelle
            onChange={() => handleMultipleChoice("none")}
          />
        </div>
      </Segment>
    </div>
  );
};

const PostureIssues = ({ answers, setAnswers }) => {
  const handleMultipleChoice = (value) => {
    let updatedIssues;
    if (value === "none") {
      updatedIssues = ["none"];
    } else if (answers.postureIssues?.includes("none")) {
      updatedIssues = [value];
    } else if (answers.postureIssues?.includes(value)) {
      updatedIssues = answers.postureIssues.filter((item) => item !== value);
    } else {
      updatedIssues = [...(answers.postureIssues || []), value];
    }
    setAnswers({ ...answers, postureIssues: updatedIssues });
  };

  return (
    <div key="postureIssues">
      <Header as="h2" textAlign="center">
        🦴 Et côté posture, ça va ?
      </Header>
      <Segment padded>
        <p>(Cochez ce qui vous concerne)</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Checkbox
            label="Douleurs cervicales (Votre cou ne vous dit pas merci 😩)"
            checked={answers.postureIssues?.includes("cervical")} //
            onChange={() => handleMultipleChoice("cervical")}
          />
          <Checkbox
            label="Mal au cou (Oui, il y a une différence avec la précédente, et vous le savez ! 😆)"
            checked={answers.postureIssues?.includes("neck")}
            onChange={() => handleMultipleChoice("neck")}
          />
          <Checkbox
            label="Douleurs aux épaules (Porter un sac invisible de 10kg, ce n'est pas une bonne idée 🎒)"
            checked={answers.postureIssues?.includes("shoulders")}
            onChange={() => handleMultipleChoice("shoulders")}
          />
          <Checkbox label="Douleurs lombalgiques (Votre dos proteste 📢)" checked={answers.postureIssues?.includes("back")} onChange={() => handleMultipleChoice("back")} />
          <Checkbox
            label="Aucune gêne posturale (Vous êtes en mode moine Shaolin 🧘)"
            checked={answers.postureIssues?.includes("none")}
            onChange={() => handleMultipleChoice("none")}
          />
        </div>
      </Segment>
    </div>
  );
};

const ThankYou = () => {
  return (
    <div key="thanks">
      <Header as="h2" textAlign="center">
        Merci pour vos réponses !
      </Header>
      <Segment padded>
        <p>Nous calculons votre indice de risque... 3, 2, 1 bingo !</p>
      </Segment>
    </div>
  );
};

const RiskIndex = ({ answers }) => {
  const [riskIndex, setRiskIndex] = useState(null);
  const { user } = useSelector((state) => state.Auth);

  useEffect(() => {
    calculateRiskIndex();
  }, []);

  useEffect(() => {
    if (riskIndex !== null && user?.id) {
      insertExercises();
      insertPauses();
      saveFatigability();
    }
  }, [riskIndex]);

  const insertPauses = async () => {
    try {
      await DeleteExistingPauses(user.id);
      const fatigabilityData = getResults(riskIndex);
      if (fatigabilityData && fatigabilityData.Pauses) {
        await InsertPauses(fatigabilityData.Pauses.hours, user.id);
      }
    } catch (error) {
      console.error("Error inserting pauses:", error);
    }
  };

  const saveFatigability = async () => {
    try {
      await InsertNewFatigability(user.id, answers, riskIndex, getRiskLevel().level);
    } catch (error) {
      console.error("Error saving fatigability:", error);
    }
  };

  const calculateRiskIndex = () => {
    // Simple risk calculation logic
    let risk = 0;

    // Screen time factor
    if (answers.screenTime === "10+") risk += 30;
    else if (answers.screenTime === "7-10") risk += 20;
    else if (answers.screenTime === "4-7") risk += 10;

    // Current practices factor (inverse - not doing anything increases risk)
    if (answers.currentPractices === "nothing") risk += 15;

    // Visual issues factor
    risk += answers.visualIssues.length * 5;

    // Posture issues factor
    risk += answers.postureIssues.length * 5;

    // Normalize to 0-100
    risk = Math.min(Math.max(risk, 0), 100);

    setRiskIndex(risk);
  };

  const getResults = (percentage) => {
    if (percentage) {
      if (percentage >= 1 && percentage <= 30) {
        return LowFatigability;
      } else if (percentage >= 30 && percentage <= 65) {
        return MediumFatigability;
      } else if (percentage > 65) {
        return HighFatigability;
      }
      return {};
    }
  };

  const insertExercises = async () => {
    try {
      // Delete existing exercises first
      await DeleteExistingExcercises(user.id);

      // Get the appropriate fatigability level based on risk index
      const fatigabilityData = getResults(riskIndex);

      if (fatigabilityData && fatigabilityData.Excercises) {
        // Prepare exercises data in the format expected by InsertExcercises
        const exercisesData = {
          Hours: fatigabilityData.Excercises.hours,
          Types: fatigabilityData.Excercises.types,
        };

        // Insert exercises
        await InsertExcercises(exercisesData, user.id);
      }
    } catch (error) {
      console.error("Error inserting exercises:", error);
    }
  };

  const getRiskLevel = () => {
    if (riskIndex > 70) return { level: "Élevé", color: "red" };
    if (riskIndex > 30) return { level: "Moyen", color: "orange" };
    return { level: "Faible", color: "green" };
  };

  return (
    <div key="riskIndex">
      <Header as="h2" textAlign="center">
        📊 Calcul de votre "indice de risque" 🔎
      </Header>
      <Segment padded>
        {riskIndex === null ? (
          <>
            <p>Nous analysons vos réponses… patience, ça charge !</p>
            <Loader active inline="centered" />
          </>
        ) : (
          <>
            <VitalityGauge Percentage={riskIndex} />
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Header as="h3" style={{ color: getRiskLevel().color }}>
                {getRiskLevel().level} risque : {riskIndex}%
              </Header>
              {getRiskLevel().level === "Faible" && <p>🟢 Continuez comme ça, vous êtes sur la bonne voie ! 🚀</p>}
              {getRiskLevel().level === "Moyen" && <p>🟠 Rien d'alarmant, mais quelques ajustements vous feraient du bien 👌</p>}
              {getRiskLevel().level === "Élevé" && <p>🔴 Pas de panique, vous ne pouvez que vous améliorer et nous allons vous y aider 🚑💆‍♂️</p>}
            </div>
          </>
        )}
      </Segment>
    </div>
  );
};

const Program = () => {
  const history = useHistory();

  return (
    <div key="program">
      <Header as="h2" textAlign="center">
        🎁 Voici votre programme personnalisé !
      </Header>
      <Segment padded>
        <p>📩 Un cocktail d'astuces, d'exercices et de conseils sur-mesure pour vous remettre d'aplomb.</p>
        <p>Vos yeux et votre dos vous diront merci ! 🙌</p>
        <Button primary fluid size="large" onClick={() => history.push("/home")} style={{ marginTop: "20px" }}>
          Commencer mon programme
        </Button>
      </Segment>
    </div>
  );
};

export default Onboarding;
